var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "HRApprove"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('legend', [_vm._v("Finance Approve")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchData.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("From date :")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fromDate",
      "type": "Date",
      "name": "fromDate",
      "placeholder": "Enter From Date"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("To date :")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "placeholder": "Enter To Date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Service Center :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.hubList,
      "selected-option": _vm.hublistObj,
      "name": "hubname",
      "placeholder": "Select hubname"
    },
    on: {
      "select": _vm.gethubname
    },
    model: {
      value: (_vm.hubname),
      callback: function($$v) {
        _vm.hubname = $$v
      },
      expression: "hubname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Debit From : ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.debitFromList,
      "selected-option": _vm.debitFromObj,
      "name": "debitFrom",
      "placeholder": "Select debitFrom"
    },
    on: {
      "select": _vm.getDebitFrom
    },
    model: {
      value: (_vm.debitFrom),
      callback: function($$v) {
        _vm.debitFrom = $$v
      },
      expression: "debitFrom"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('debitFrom')),
      expression: "errors.has('debitFrom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('debitFrom')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.debitFrom == 'ServiceCenter') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Debit From Type")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.debitFromTypeList,
      "selected-option": _vm.debitFromTypeObj,
      "name": "debitFromType",
      "placeholder": "Select debitFrom"
    },
    on: {
      "select": _vm.getdebitFromTypeObject
    },
    model: {
      value: (_vm.debitFromType),
      callback: function($$v) {
        _vm.debitFromType = $$v
      },
      expression: "debitFromType"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('debitFrom')),
      expression: "errors.has('debitFrom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('debitFrom')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.debitFrom == 'ServiceCenter') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("SR/Staff Debit : ")]), _vm._v(" "), _c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.getEmpList,
      "selected-option": _vm.staffDebitObj,
      "name": "staffDebit",
      "placeholder": "Select SR / staff debit"
    },
    on: {
      "select": _vm.getSelectDebitSRStaff
    },
    model: {
      value: (_vm.staffDebit),
      callback: function($$v) {
        _vm.staffDebit = $$v
      },
      expression: "staffDebit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.debitFrom == 'Courier') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Super Agent : ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.SuperAgentTypeData,
      "selected-option": _vm.SuperAgentObj,
      "name": "SuperAgentType",
      "placeholder": "Select Super Agent"
    },
    on: {
      "select": _vm.getSuperAgent
    },
    model: {
      value: (_vm.SuperAgentType),
      callback: function($$v) {
        _vm.SuperAgentType = $$v
      },
      expression: "SuperAgentType"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SuperAgentType')),
      expression: "errors.has('SuperAgentType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SuperAgentType')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Debit Mode : ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.debitModeList,
      "selected-option": _vm.debitModeObj,
      "name": "debitMode",
      "placeholder": "Select debitMode"
    },
    on: {
      "select": _vm.getDebitMode
    },
    model: {
      value: (_vm.debitMode),
      callback: function($$v) {
        _vm.debitMode = $$v
      },
      expression: "debitMode"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('debitFrom')),
      expression: "errors.has('debitFrom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('debitFrom')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Employee Id :")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employeeID),
      expression: "employeeID"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "employeeID",
      "type": "text",
      "name": "employeeID",
      "placeholder": "Enter Employee ID"
    },
    domProps: {
      "value": (_vm.employeeID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.employeeID = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping Id :")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "shippingID",
      "type": "text",
      "name": "shippingID",
      "placeholder": "Enter Shipping ID"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(":")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.StatusList,
      "selected-option": _vm.StatusObj,
      "name": "status",
      "placeholder": "Select status"
    },
    on: {
      "select": _vm.getStatus
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status')),
      expression: "errors.has('status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('status')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Vertical")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Vertical),
      expression: "Vertical"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "Vertical",
      "id": "Vertical"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Vertical = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2B"
    }
  }, [_vm._v("B2B")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2C"
    }
  }, [_vm._v("B2C")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")]), _vm._v("   \n                "), _c('span', {
    staticClass: "btn btn-primary linkforspan",
    on: {
      "click": _vm.exportCSV
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Export")])])])])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchflag == true),
      expression: "searchflag==true"
    }],
    staticClass: "approvalRecords"
  }, [_c('b-card', [_c('div', {}, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.HRApproveAllRecords.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Invoice No : ")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceNo),
      expression: "invoiceNo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "invoiceNo",
      "type": "text",
      "name": "invoiceNo",
      "placeholder": "Enter invoice no"
    },
    domProps: {
      "value": (_vm.invoiceNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoiceNo = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "FAEaiseDebit col-md-3 mt-4"
  }, [_c('span', {
    staticClass: "reloadData"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-lg",
    attrs: {
      "title": "click to Refresh"
    },
    on: {
      "click": function($event) {
        return _vm.refreshdata()
      }
    }
  }), _vm._v(" ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalRecords) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-4",
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.selectedItems.length == 0
    }
  }, [_vm._v("Approve")])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "batches table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "batchTable",
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_c('thead', {
    staticClass: "thead"
  }, [_c('tr', [_c('th', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        return _vm.selectItems($event)
      }
    }
  })]), _vm._v(" "), (_vm.ApproveResultResponse.length > 0) ? _c('th', [_vm._v("Transaction status")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Zone")]), _vm._v(" "), _c('th', [_vm._v("Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Debit From")]), _vm._v(" "), _c('th', [_vm._v("Debit ID")]), _vm._v(" "), _c('th', [_vm._v("Debit Concern")]), _vm._v(" "), _c('th', [_vm._v("Total Debit Amount")]), _vm._v(" "), _c('th', [_vm._v("Concern Person Debit Amount")]), _vm._v(" "), _c('th', [_vm._v("Remaining Amount")]), _vm._v(" "), _c('th', [_vm._v("Total No. Of Cases")]), _vm._v(" "), _c('th', [_vm._v("Debit Mode")]), _vm._v(" "), _c('th', [_vm._v("InvoiceNo / DepositeDate")]), _vm._v(" "), _c('th', [_vm._v("Docket Number ")]), _vm._v(" "), _c('th', [_vm._v("Bank Challan No. ")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Created By")]), _vm._v(" "), _c('th', [_vm._v("Last Modified Date")]), _vm._v(" "), _c('th', [_vm._v("Last Modified By")]), _vm._v(" "), _c('th', [_vm._v("Comments")]), _vm._v(" "), _c('th', [_vm._v("Attachment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.HRDebitData), function(val) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItems),
        expression: "selectedItems"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": val.shipmentlostdebitnoteid,
        "checked": Array.isArray(_vm.selectedItems) ? _vm._i(_vm.selectedItems, val.shipmentlostdebitnoteid) > -1 : (_vm.selectedItems)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.shipmentlostdebitnoteid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItems = $$c
          }
        }
      }
    })]), _vm._v(" "), (_vm.ApproveResultResponse.length) ? _c('td', _vm._l((_vm.ApproveResultResponse), function(result) {
      return (result.RShipmentLostDebitNoteID == val.shipmentlostdebitnoteid) ? _c('span', {
        class: [result.code == 200 ? 'successlink' : 'failurelink']
      }, [_vm._v(_vm._s(result.message))]) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(val.Shippingid))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.hubzonename))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.servicecentername))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.debitfromtype))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(val.debitid))])]), _vm._v(" "), _c('td', {
      staticClass: "link"
    }, [_vm._v(" " + _vm._s(val.employeename))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.TotalDebitAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ConcernPersonDebitAmount))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.RemainingAmount))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.NoOfCases))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.debitmode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("isnull")(val.cihdepositdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("isnull")(val.docketnumber)) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.bankchalanno) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.status))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(val.createddate))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(val.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(_vm._f("isnull")(val.lastmodifieddate)))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(_vm._f("isnull")(val.lastmodifiedby)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.comments))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "90px"
      }
    }, [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getShipmentAttachmentPopup(val.Shippingid, val.attachment, val.debitfromtype)
        }
      }
    }, [_vm._v("View Image")])])])
  }), 0)])]), _vm._v("\n          \n           "), _c('div', [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.loader
    },
    on: {
      "update:active": function($event) {
        _vm.loader = $event
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-dialog modal-lg",
      "id": "raiseHRDebitNotePopupDiv"
    },
    on: {
      "ok": function($event) {
        _vm.raiseHRDebitNotePopupflag = false
      }
    },
    model: {
      value: (_vm.raiseHRDebitNotePopupflag),
      callback: function($$v) {
        _vm.raiseHRDebitNotePopupflag = $$v
      },
      expression: "raiseHRDebitNotePopupflag"
    }
  }, [_c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Raise HR Debit Note - Customised /Edit ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeonPopupforraiseHRDebitNote
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v("Debit Concern Person")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v(_vm._s(_vm.shippingDetailes.employeename))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v("Designation")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v(_vm._s(_vm.shippingDetailes.Designation))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v("Employee Id")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v(_vm._s(_vm.shippingDetailes.srid))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v("Total Debit Amount")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v(_vm._s(_vm.shippingDetailes.ConcernPersonDebitAmount))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v("RM Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v(_vm._s(_vm.shippingDetailes.RMName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('h6', [_vm._v("Payment Option")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 lg-auto"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentOption),
      expression: "paymentOption"
    }],
    attrs: {
      "type": "radio",
      "value": "totalPayment"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentOption, "totalPayment")
    },
    on: {
      "change": function($event) {
        _vm.paymentOption = "totalPayment"
      }
    }
  }), _vm._v(" "), _c('h6', [_vm._v("Total Payment")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 lg-auto"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentOption),
      expression: "paymentOption"
    }],
    attrs: {
      "type": "radio",
      "value": "customizedDebitValue"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentOption, "customizedDebitValue")
    },
    on: {
      "change": function($event) {
        _vm.paymentOption = "customizedDebitValue"
      }
    }
  }), _vm._v(" "), _c('h6', [_vm._v("Customized Debit Value")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 lg-auto"
  })]), _vm._v(" "), (_vm.customizedDebitValueData.length != 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.paymentOption == 'customizedDebitValue' && _vm.customizedDebitValueData.length != 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 lg-auto"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 lg-auto"
  }, [_c('table', {
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px",
      "border": "1px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Month")]), _vm._v(" "), _c('th', [_vm._v("Customized Debit Amount")]), _vm._v(" "), _c('th', [_vm._v("No Of Cases")]), _vm._v(" "), _c('th', [_vm._v("Total Debit Amount")]), _vm._v(" "), _c('th', [_vm._v("Paid Debit Amount")]), _vm._v(" "), _c('th', [_vm._v("Remaining Debit Amount")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.customizedDebitValueData), function(val) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(val.month))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.customizedDebitValue),
        expression: "customizedDebitValue"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true,
        'error': _vm.errors.has('customizedDebitValue')
      },
      attrs: {
        "type": "input"
      },
      domProps: {
        "value": (_vm.customizedDebitValue)
      },
      on: {
        "change": _vm.customizedDebit,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.customizedDebitValue = $event.target.value
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.customizedDebitErrorFlag),
        expression: "customizedDebitErrorFlag"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true,
        'error': _vm.errors.has('customizedDebitErrorFlag')
      },
      attrs: {
        "type": "hidden",
        "name": "customizedDebitErrorFlag"
      },
      domProps: {
        "value": (_vm.customizedDebitErrorFlag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.customizedDebitErrorFlag = $event.target.value
        }
      }
    }), _vm._v(" "), (parseInt(_vm.customizedDebitValue) > parseInt(val.totalAmount) || parseInt(_vm.customizedDebitValue) < 5000) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("Customized Debit Amount should not be greater than Total Debit Amount and less than 5000.")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.noOfCases))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.totalAmount))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.paidAmount))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.remainingAmount))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.paymentOption == 'customizedDebitValue') ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('h6', [_vm._v("Comments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 lg-auto"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('comment')
    },
    attrs: {
      "rows": "2",
      "name": "comment",
      "id": "comment"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.comment')),
      expression: "errors.has('form-1.comment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Comment.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('h6', [_vm._v("Details of Marked Debit")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 lg-auto PopupraiseHREditTable",
    staticStyle: {
      "height": "100px",
      "overflow": "auto"
    }
  }, [_c('table', {
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Debit Date")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Remaining Debit Amount")]), _vm._v(" "), _c('th', [_vm._v("Paid Debit Amount")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.DetailsofMarkedDebit), function(val) {
    return _c('tr', [_c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.shipmetsDeatilespopup(val.ShippingID)
        }
      }
    }, [_vm._v(" " + _vm._s(val.ShippingID))])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DebitDate))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Status))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DebitAmount))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.RemainingAmount))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.PaidAmount))])])
  }), 0)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Raise Debit")])])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-dialog modal-lg",
      "id": "shipmetDeatileDiv"
    },
    on: {
      "ok": function($event) {
        _vm.shipmetDeatileFlag = false
      }
    },
    model: {
      value: (_vm.shipmetDeatileFlag),
      callback: function($$v) {
        _vm.shipmetDeatileFlag = $$v
      },
      expression: "shipmetDeatileFlag"
    }
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Details of Marked Debit ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closepopupForShipment
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('h6', [_vm._v("Details of Marked Debit")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 lg-auto PopupraiseHREditTable",
    staticStyle: {
      "height": "100px",
      "overflow": "auto"
    }
  }, [_c('table', {
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("AWB Number")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Debit Date")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipingInfo), function(val) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(val.DebitFrom))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DebitAmount))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DebitDate))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Status))])])
  }), 0)])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.getAttachmentFlag = false
      }
    },
    model: {
      value: (_vm.getAttachmentFlag),
      callback: function($$v) {
        _vm.getAttachmentFlag = $$v
      },
      expression: "getAttachmentFlag"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Attachment ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAttachmentPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto"
  }, [(_vm.getInvestigationImgs.length != 0) ? _c('div', {
    staticClass: "header",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticClass: "text-center",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("Investigation Images")])]) : _vm._e(), _vm._v(" "), (_vm.getInvestigationImgs.length != 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getInvestigationImgs), function(item, index) {
    return _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "margin": "15px 0px"
      }
    }, [(item.fileType != 'pdf') ? _c('div', {
      key: index,
      staticClass: "media-item",
      on: {
        "click": function($event) {
          return _vm.openModal(item)
        }
      }
    }, [(item.fileType === 'image') ? _c('img', {
      attrs: {
        "src": item.filePath,
        "alt": "Image"
      }
    }) : _vm._e(), _vm._v(" "), (item.fileType === 'video') ? _c('video', {
      attrs: {
        "src": item.filePath,
        "controls": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(item.fileType === 'pdf') ? _c('a', {
      attrs: {
        "href": "item.filePath",
        "target": "_blank",
        "download": "item.fileName"
      }
    }, [_vm._v(_vm._s(item.fileName))]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getInvestigationImgs.length != 0) ? _c('hr', {
    staticStyle: {
      "margin": "15px 0px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticClass: "text-center",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("Raise Debit Images")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.getAttachmentListData.length == 0) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('p', {
    staticClass: "text-center",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("No Attachments Available.! ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getAttachmentListData), function(item, index) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [(item.fileType != 'pdf') ? _c('div', {
      key: index,
      staticClass: "media-item",
      on: {
        "click": function($event) {
          return _vm.openModal(item)
        }
      }
    }, [(item.fileType === 'image') ? _c('img', {
      attrs: {
        "src": item.filePath,
        "alt": "Image"
      }
    }) : _vm._e(), _vm._v(" "), (item.fileType === 'video') ? _c('video', {
      attrs: {
        "src": item.filePath,
        "controls": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(item.fileType === 'pdf') ? _c('a', {
      attrs: {
        "href": "item.filePath",
        "target": "_blank",
        "download": "item.fileName"
      }
    }, [_vm._v(_vm._s(item.fileName))]) : _vm._e()])])
  })], 2)])])])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14b9d720","hasScoped":true}!./src/views/components/LOST/FinanceApprove/FinanceApprove.component.html
// module id = 1373
// module chunks = 1